
// 广东直连粤享5G App Bridge

import { Toast } from 'vant'

const appId = '18000885' // 微医appid：18000885 广东移动 提供

// 延迟 死循环指定的时间
// function delay (duration) {
//   var start = Date.now()
//   while (Date.now() - start < duration) {}
// }

var equipmentType = equipmentTypeGet()

// 获取设备信息
function equipmentTypeGet () {
    if (/android/.test(navigator.userAgent.toLowerCase())) {
        return 'android'
    } else if (/ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())) {
        return 'ios'
    } else {
        return false
    }
}
// 判断设备安卓，IOS方法
function setupWebViewJavascriptBridge (callback) {
    if (equipmentType === 'android') {
        if (window.WebViewJavascriptBridge) {
            callback(window.WebViewJavascriptBridge)
        } else {
            document.addEventListener(
                'WebViewJavascriptBridgeReady',
                function () {
                    callback(window.WebViewJavascriptBridge)
                },
                false
            )
        }
    } else if (equipmentType === 'ios') {
        if (window.WebViewJavascriptBridge) {
            return callback(window.WebViewJavascriptBridge)
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback)
        }
        window.WVJBCallbacks = [callback]
        var WVJBIframe = document.createElement('iframe')
        WVJBIframe.style.display = 'none'
        WVJBIframe.src = 'https://__bridge_loaded__'
        document.documentElement.appendChild(WVJBIframe)
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe)
        }, 100)
    }
}
// 传值认定
setupWebViewJavascriptBridge(function (bridge = {}) {
    if (equipmentType === 'android') {
      try {
        bridge.init && bridge.init(function (message, responseCallback) {
          console.log('JS got a message', message)
          var data = {
              'Javascript Responds': '测试中文!'
          }
          if (responseCallback) {
              console.log('JS responding with', data)
              responseCallback(data)
          }
        })
      } catch (e) {
        console.warn(`bridge.init 错误: ${e} `)
      }
      try {
        bridge.registerHandler && bridge.registerHandler('functionInJs', function (data, responseCallback) {
            console.log('data from Java: = ' + data)
            if (responseCallback) {
                var responseData = 'Javascript Says Right back aka!'
                responseCallback(responseData)
            }
        })
      } catch (e) {
        console.warn(`bridge.registerHandler 错误: ${e} `)
      }
    }
})

/**
 * 做所有的请求前都需要申请H5-token，更多接口，查看demo文件
 * 获取H5token/设备udid 做单点登录使用
 * 1. 判断ua环境-初始化
 * 2. 申请token
 * 3. 获取设备信息的udid
 * 3. 没有登录：请求登录 --> 申请token【之前申请的会失效】 --> 根据token/udid做单点登录
 *    已经登录：根据token/udid做单点登录 15918651027  5gPlusInit
 */
class GdyxAppBridge {
  constructor () {
    this.appid = appId
    this.isErr = false
    this.res = ''
    this.ua = null // android ios
    this.timerFn = null
    this.timerNum = 0
    this.token = ''
    this.isLogin = false
    this.loginResponse = ''
    this.udid = ''
  }

  callApp (name, data, callback) {
    return new Promise((resolve, reject) => {
      if (equipmentType === 'android') {
        if (!window.WebViewJavascriptBridge) {
          const e = false
          callback && callback(e)
          return resolve(false)
        }
        window.WebViewJavascriptBridge.callHandler(
          name,
          JSON.stringify(data),
          function (responseData) {
            var res = responseData && JSON.parse(responseData)
            callback && callback(res)
            return resolve(res)
          }
        )
      } else if (equipmentType === 'ios') {
        setupWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler(name, data, function (responseData) {
            var res = responseData && JSON.parse(responseData)
            callback && callback(res)
            return resolve(res)
          })
        })
      } else {
        Toast.fail({ duration: 0, message: `设备错误: ${equipmentType}` })
      }
    })
  }
}

export const getLoginResquestData = async (query) => {
  const { mockPhoneNo } = query
  if (mockPhoneNo) { // mockPhoneNo不需要调app接口
    return { token: '-', udid: '-', appid: appId }
  }
  const setup = new GdyxAppBridge()
  const appidObj = { appId: setup.appid }
  if (!equipmentType) return false

  const getTokenPromise = () => {
    setup.timerNum = 0
    return new Promise((resolve, reject) => {
        const setIntervalFn = () => {
          setup.timerNum++
          // Toast({ duration: 0, message: `${setup.timerNum} 申请H5token` })
          console.log(`${setup.timerNum} 申请H5token`)

          if (setup.timerNum >= 10 || setup.token) {
              clearInterval(setup.timerFn)
              resolve(setup.token)
          }

          if (setup.timerNum >= 10 && !setup.token) {
            console.log(`${setup.timerNum} 申请H5token 无响应`)
            Toast.fail({ duration: 4000, message: `申请H5token 无响应` })
          }

          setup.callApp('applyTokenForG5', appidObj, function (res) {
              const token = res && res.data && res.data.token
              setup.token = token
              if (setup.timerNum >= 10 && !(res && +res.code === 0 && res.data && res.data.token)) {
                console.log(`${setup.timerNum} 申请H5token 响应异常: ${res && JSON.stringify(res)}`)
                Toast.fail({ duration: 4000, message: `${setup.timerNum} 申请H5token 响应异常: ${res && JSON.stringify(res)}` })
              }
          })

          return setIntervalFn
        }
        setup.timerFn = setInterval(setIntervalFn(), 1000)
    })
  }
  // 1. 请求H5 token
  await getTokenPromise()

  if (!setup.token) return false

  // 2. 检查登录
  const resquestData = { token: setup.token }
  await setup.callApp('checkLoginForG5', resquestData, res => {
    setup.isLogin = res.data && res.data.isLogin
  })

  // 3. 获取设备信息
  await setup.callApp('getDeviceInfoForG5', resquestData, res => {
    setup.udid = res.data && res.data.udid
  })

  if (!setup.udid) return false

  if (setup.isLogin) {
    return { token: setup.token, udid: setup.udid, appid: appId }
  } else {
    // 请求登录
    await setup.callApp('requestLoginForG5', resquestData, res => {
      if (+res.code === 1002) {
        setup.loginResponse = res
      }
    })

    if (!setup.loginResponse) return false // {"code":1002,"msg":"用户登录成功"}

    // 未登录情况下, 调用客户端组件进行登录, 之前申请的token【是游客的token】会失效, 要重新申请【当前用户的token】
    await setup.callApp('applyTokenForG5', appidObj, res => {
      setup.token = res.data && res.data.token
    })

    if (!setup.token) return false

    return { token: setup.token, udid: setup.udid, appid: appId }
  }
}

// 微信小程序跳转
export const jumpMiniProgram = async (originalId, path = '') => {
  const setup = new GdyxAppBridge()
  const appidObj = { appId: setup.appid }
  if (!equipmentType) return false

  const getTokenPromise = () => {
    setup.timerNum = 0
    return new Promise((resolve, reject) => {
        const setIntervalFn = () => {
          setup.timerNum++
          if (setup.timerNum >= 10 || setup.token) {
              clearInterval(setup.timerFn)
              resolve(setup.token)
          }
          // Toast({ duration: 0, message: `${setup.timerNum} 申请H5token ` })
          setup.callApp('applyTokenForG5', appidObj, function (res) {
              const token = res && res.data && res.data.token
              if (setup.timerNum >= 10 && (+res.code !== 0 || !token)) {
                Toast.fail({ duration: 0, message: `${setup.timerNum} 申请H5token 响应异常: ${res && JSON.stringify(res)}` })
              }
              setup.token = token
          })
          return setIntervalFn
        }
        setup.timerFn = setInterval(setIntervalFn(), 1000)
    })
  }
  // 1. 请求H5 token
  await getTokenPromise()

  if (!setup.token) return false

  // 2. 跳转 微医科技小程序
  // const resquestData = { originalId: 'gh_1177b0324325', appid: 'wx6614f8744262e988', path: '/pages/index/index', token: setup.token }
  const resquestData = { appid: originalId, path, token: setup.token }
  await setup.callApp('jumpMiniProgramFor5G', resquestData, res => {
    // Toast({ duration: 0, message: `跳转微信小程序 响应: ${JSON.stringify(res)}` })
    setup.res = res
  })

  return setup.res
}



// WEBPACK FOOTER //
// ./src/utils/gdzlyx-bridge.js